import requests from "./httpServices";

export const deleteElement = async (elementId) => {
  await requests.post(`/element/delete`, {
    id: elementId,
  });
};

export const renameElement = async (elementId, name) => {
  await requests.post(`/element/rename`, {
    id: elementId,
    name,
  });
};

export const updateFolderOrder = async (updatedFolders) => {
  await requests.post(`/element/update-folders-order`, {
    folders: updatedFolders,
  });
};

export const uploadFiles = async (formData, folderId) => {
  return await requests.post(`/element/file-upload/${folderId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getFiles = async (folderId) => {
  return await requests.get(`/element/files/${folderId}`);
};

export const createCta = async (data) => {
  return await requests.post("/element/create-cta-preset", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const createPrompter = async (data) => {
  return await requests.post("/element/create-prompter-preset", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getFolderElements = async (meetingId) => {
  return await requests.get("/element/all-elements?meetingId=" + meetingId);
}

export const getPrompterFile = async (folderId) => {
  return await requests.get(`/element/prompter/${folderId}`);
}

export const importElement = async (formData) => {
  return await requests.post(`/element/import-element`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};